import { render } from "./sponsors.vue?vue&type=template&id=92693518&scoped=true"
import script from "./sponsors.vue?vue&type=script&lang=js"
export * from "./sponsors.vue?vue&type=script&lang=js"

import "./sponsors.vue?vue&type=style&index=0&id=92693518&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-92693518"

export default script